import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router'
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { AlertasComponent } from './alertas/alertas.component';
import { FormContentChatComponent } from './formcontentchat/formcontentchat.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { PaymentHistoryComponent } from './paymenthistory/paymenthistory.component';
import { BillsHistoryComponent } from './billshistory/billshistory.component';
import { UsersAndPermissionsComponent } from './usersandpermissions/usersandpermissions.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatInputModule} from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule,MatNativeDateModule,MatDialogModule, MatButtonModule ,MatTooltipModule} from '@angular/material';
import { HttpClientModule} from '@angular/common/http';
import { Service } from './services';
import { Bridge } from './bridge';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { LoadingScreenMinComponent } from './components/loading-screen-min/loading-screen-min.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CarouselNewsComponent } from './home/components/carousel-news/carousel-news.component';
import { PaymentsInvoicesComponent } from './home/components/payments-invoices/payments-invoices.component';
import { AccountsSubscribersComponent } from './home/components/accounts-subscribers/accounts-subscribers.component';
import { SupportComponent } from './home/components/support/support.component';
import { ProfileComponent } from './profile/profile.component';
import { CompanyInformationComponent } from './profile/components/company-information/company-information.component';
import { UpdateEmailComponent } from './profile/components/update-email/update-email.component';
import { ChangePasswordComponent } from './profile/components/change-password/change-password.component';
import { PostalAddressComponent } from './profile/components/postal-address/postal-address.component';
import { SecurityQuestionsComponent } from './profile/components/security-questions/security-questions.component';
import { PasswordValidatorComponent } from './components/password-validator/password-validator.component';
import { OptionsComponent } from './components/options/options.component';
import { FrequentQuestionsComponent } from './frequent-questions/frequent-questions.component';
import { BillsManagementComponent } from './bills-management/bills-management.component';
import { RegisterComponent } from './register/register.component';
import { RegisterSubscriberComponent } from './register/components/register-subscriber/register-subscriber.component';
import { SecurityCodeComponent } from './register/components/security-code/security-code.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { PasswordSetComponent } from './register/components/password-set/password-set.component';
import { ChatComponent } from './chat/chat.component';
import { ResetKeyComponent } from './forgotpassword/components/reset-key/reset-key.component';
import { SecurityCheckComponent } from './forgotpassword/components/security-check/security-check.component';
import { SecurityQuestionsPasswordComponent } from './forgotpassword/components/security-questions-password/security-questions-password.component';
import { PaperlessBoxComponent } from './components/paperless-box/paperless-box.component';
import { UsersPermissionsComponent } from './users-permissions/users-permissions.component';
import { CreateUserComponent } from './users-permissions/components/create-user/create-user.component';
import { PermissionAssignmentComponent } from './users-permissions/components/permission-assignment/permission-assignment.component';
import { SummaryConfirmationComponent } from './users-permissions/components/summary-confirmation/summary-confirmation.component';
import { ForgotsubcriberComponent } from './forgotpassword/components/forgotsubcriber/forgotsubcriber.component';
import { PasswordSendingComponent } from './forgotpassword/components/password-sending/password-sending.component';
import { PopupQuestionComponent } from './home/components/popup-question/popup-question.component';
import { ModifyaccountsComponent } from './modifyaccounts/modifyaccounts.component';
import { RolesComponent } from './roles/roles.component';
import { TermsComponent } from './register/components/terms/terms.component';
import { SubscriberdetailComponent } from './subscriberdetail/subscriberdetail.component';
import { EquipmentInfoComponent } from './subscriberdetail/components/equipment-info/equipment-info.component';
import { PlanInfoComponent } from './subscriberdetail/components/plan-info/plan-info.component';
import { UsageInfoComponent } from './subscriberdetail/components/usage-info/usage-info.component';
import { GraphicComponent } from './subscriberdetail/components/graphic/graphic.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { LoginupdateComponent } from './loginupdate/loginupdate.component';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { PaperlessComponent } from './paperless/paperless.component';
import { PaperlessModuleComponent } from './paperless/components/paperless-module/paperless-module.component';
import { OnlycoinDirective } from './directives/onlycoin.directive';
import { PoliticsComponent } from './politics/politics.component';
import { PoliticaPagoComponent } from './politics/components/politica-pago/politica-pago.component';
import { PoliticaPrivacidadComponent } from './politics/components/politica-privacidad/politica-privacidad.component';
import { TerminosUsoComponent } from './politics/components/terminos-uso/terminos-uso.component';
import {EventBusService} from 'ngx-eventbus';
//prueba jesus
@NgModule({
  declarations: [
    AppComponent,
    PaperlessComponent,
    LoginComponent,
    FooterComponent,
    PoliticsComponent,
    PoliticaPagoComponent,
    PoliticaPrivacidadComponent,
    TerminosUsoComponent,
    AlertasComponent,
    FormContentChatComponent,
    HomeComponent,
    PaymentHistoryComponent,
    BillsHistoryComponent,
    UsersAndPermissionsComponent,
    MenuComponent,
    LoadingScreenComponent,
    LoadingScreenMinComponent,
    CarouselNewsComponent,
    PaymentsInvoicesComponent,
    AccountsSubscribersComponent,
    SupportComponent,
    ProfileComponent,
    PaperlessModuleComponent,
    CompanyInformationComponent,
    UpdateEmailComponent,
    ChangePasswordComponent,
    PostalAddressComponent,
    SecurityQuestionsComponent,
    PasswordValidatorComponent,
    OptionsComponent,
    FrequentQuestionsComponent,
    BillsManagementComponent,
    RegisterComponent,
    RegisterSubscriberComponent,
    SecurityCodeComponent,
    ForgotpasswordComponent,
    PasswordSetComponent,
    ChatComponent,
    ResetKeyComponent,
    SecurityCheckComponent,
    SecurityQuestionsPasswordComponent,
    PaperlessBoxComponent,
    UsersPermissionsComponent,
    CreateUserComponent,
    PermissionAssignmentComponent,
    SummaryConfirmationComponent,
    ForgotsubcriberComponent,
    PasswordSendingComponent,
    PopupQuestionComponent,
    ModifyaccountsComponent,
    RolesComponent,
    TermsComponent,
    SubscriberdetailComponent,
    EquipmentInfoComponent,
    PlanInfoComponent,
    UsageInfoComponent,
    GraphicComponent,
    LoginupdateComponent,
    OnlyNumberDirective,
    OnlycoinDirective
  ],
  imports: [
    MatRadioModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    BrowserModule,
    HttpClientModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatDialogModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule, // dynamically imports firebase/analytics
    RouterModule.forRoot([
      {
        path:'login',
        component:LoginComponent
      },
      {
        path:'login/:token',
        component:LoginComponent
      },
      {
        path:'home',
         component:HomeComponent
      },
      {
        path:'paymenthistory',
         component:PaymentHistoryComponent
      },
      {
        path:'billshistory',
         component:BillsHistoryComponent
      },
      {
        path:'billsmanagement',
         component:BillsManagementComponent
      },
      {
        path:'usersandpermissions',
         component:UsersAndPermissionsComponent
      },
      {
        path:'userspermissions',
         component:UsersPermissionsComponent
      },
      {
        path:'roles',
         component:RolesComponent
      },
      {
        path:'modifyaccounts',
         component:ModifyaccountsComponent
      },
      {
        path:'profile',
         component:ProfileComponent,
         children: [
          {
              path: ':id',
              component:RegisterComponent

          }
        ]
      },
      {
        path:'frequentquestions',
         component:FrequentQuestionsComponent
      },
      {
        path:'register',
         component:RegisterComponent
      },
      {
        path:'forgotpassword',
         component:ForgotpasswordComponent
      },
      {
        path:'subscriberdetail',
         component:SubscriberdetailComponent
      },
      {
        path:'politics',
         component:PoliticsComponent,
         children: [
          {
              path: ':id',
              component:RegisterComponent
          }
        ]
      },
      {
        path:'loginupdate',
         component:LoginupdateComponent
      },
      {
        path:'',
        component:LoginComponent
      },
      {
        path:'paperless',
         component:PaperlessComponent
      },
  ]),
    CarouselModule.forRoot()],
  providers: [Service,Bridge,LoadingScreenComponent, EventBusService],
  bootstrap: [AppComponent],
  entryComponents:[AlertasComponent,FormContentChatComponent,PopupQuestionComponent,TermsComponent],
  exports:[AngularFireModule]
})
export class AppModule { }
